import React from 'react';
import Radium from 'radium';
import { Link } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';

import karty from '../../../../../assets/images/karty.jpg';

@Radium
export default class GetCardGame extends React.Component {
  render() {
    return (
      <Row>
        <Col md={6}>
          <img src={karty} style={styles.cards} />
        </Col>
        <Col md={6}>
          <ul style={styles.ul}>
            <li style={styles.li}>vzdělávací hra na významné události od roku 1918</li>
            <li style={styles.li}>vhodná výuková pomůcka na přestávky i zkoušení</li>
            <li style={styles.li}>speciální grafika od Dušana DAx Axmanna</li>
            <li style={styles.li}>doporučený věk hraní od šesté třídy</li>
            <li style={styles.li}>doporučený počet hráčů 2 - 6</li>
          </ul>
          <Link style={styles.cta} to="https://1url.cz/@karetnihra" target="_blank" className="btn btn-primary btn-lg">Koupit karetní hru</Link>
        </Col>
      </Row>
    );
  }
}

const styles = {
  cta: {
    marginLeft: '12%',
    marginTop: 30,
    width: '50%',
    backgroundColor: '#5d9f51',
    borderColor: '#5d9f51'
  },
  cards: {
    width: '80%',
    marginLeft: '15%',
    borderRadius: '10px',
    '@media (max-width: 571px)': {
      width: '50%',
      margin: '0 25%'
    }
  },
  ul: {
    marginTop: 60
  },
  li: {
    marginBottom: 10
  }
};



// WEBPACK FOOTER //
// ./src/browser/Feature/components/get_card_game/index.jsx